import { useEffect, useRef, useState } from "react";
import { HeroAgents } from "./HeroAgents.tsx";
import { useDemoPlayer } from "./demo/use-demo-player.ts";
import { WorkbenchReplica } from "./replica/WorkbenchReplica.tsx";

export const STAGE_WIDTH = 1240;
export const STAGE_HEIGHT = 860;

export function ProductStage() {
  const player = useDemoPlayer();
  const frameRef = useRef<HTMLDivElement>(null);
  const [scale, setScale] = useState(1);

  useEffect(() => {
    const frame = frameRef.current;
    if (!frame) return;
    const observer = new ResizeObserver((entries) => {
      const width = entries[0]?.contentRect.width ?? STAGE_WIDTH;
      setScale(Math.min(1, width / STAGE_WIDTH));
    });
    observer.observe(frame);
    setScale(Math.min(1, frame.clientWidth / STAGE_WIDTH));
    return () => observer.disconnect();
  }, []);

  return (
    <div className="product-stage">
      <HeroAgents agents={player.state.agents} reducedMotion={player.reducedMotion} />
      <div
        ref={frameRef}
        className="product-stage-frame"
        onMouseEnter={player.pause}
        onMouseLeave={player.resume}
      >
        <div className="product-stage-window">
          <div className="traffic-lights" aria-hidden>
            <span className="traffic red" />
            <span className="traffic yellow" />
            <span className="traffic green" />
          </div>
          <div className="product-stage-clip" style={{ height: STAGE_HEIGHT * scale }}>
            <div
              className="product-stage-inner"
              style={{
                width: STAGE_WIDTH,
                height: STAGE_HEIGHT,
                transform: `scale(${scale})`
              }}
            >
              <WorkbenchReplica state={player.state} elapsed={player.elapsed} onSelect={player.select} />
            </div>
          </div>
        </div>
      </div>
      <p className="product-stage-hint">演示会自动播放 · 点击收件箱、线程、项目、智能体或文件查看同一条故事</p>
    </div>
  );
}
